import "../../../../styles/page/order.scss";

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Icon, { iconColor, iconTypes } from "../../../common/components/Icon";
import {TitleTab, TitleTabs} from "../../../common/components/TitleTabs.jsx";

import ContentWrapper from "../../../common/components/ContentWrapper.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import MyListCard from "./MyListCard.jsx";
import PropTypes from "prop-types";
import React from "react";
import ShoppingCart from "../../components/order/ShoppingCart.jsx";
import {scssVariables} from "../../../common/util/config.jsx";
//import {updateListSortOrder} from  "../../actions/productLists.js";
import {withRouter} from "react-router-dom";

class MyListPage extends React.PureComponent {
    constructor(props){
        super(props);                
        this.calculateProductDisplayHeight = this.calculateProductDisplayHeight.bind(this);
        this.calculateShoppingCartHeight = this.calculateShoppingCartHeight.bind(this);
        this.calculateProductDisplayWidth = this.calculateProductDisplayWidth.bind(this);
        this.loadMoreSearchResaults = this.loadMoreSearchResaults.bind(this);
        this.createNewList = this.createNewList.bind(this);
        this.sortLists = this.sortLists.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.createDraggableLists = this.createDraggableLists.bind(this);
        this.createDraggableCards = this.createDraggableCards.bind(this);
        this.createCards = this.createCards.bind(this);
    }
    
    UNSAFE_componentWillMount() {
        const {
            activeOrder,
            getMyLists,
            initiateCurrentOrder,
            getOrderFeeLimits,
            getOrderVolumeDiscounts,
        } = this.props;
        getMyLists();
        getOrderFeeLimits();
        getOrderVolumeDiscounts();
        if( activeOrder && activeOrder.loading==false && activeOrder.shipmentId==null) {
            initiateCurrentOrder();
        }
    }
    onDragEnd(result) {
        const {
            updateListSortOrder,
        } = this.props;

        // dropped outside the list
        if (!result.destination) {
            return;
        }

        //swap places
        updateListSortOrder(result.source.index, result.destination.index);
    }

    createDraggableLists() {
        const drag = (
            <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{width:"100%"}}
                        >
                            {
                                this.createDraggableCards()
                            }
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>);
        return drag;
    }

    createDraggableCards()
    {
        const {
            localization,
            productLists,
            addRemoveProductToTemporaryOrder,
            deviceType,
            activeOrder,
            productView,
            addMyListToOrder,
            downloadListPdf,
            history,
            setModal,
        } = this.props;
        const productDisplayWidth = this.calculateProductDisplayWidth();
        const nodePrd = [];
        for(let i=0; i<productLists.customLists.length; i++) {
            const listId = productLists.customLists[i].myListId;
            if( listId>=0){
                nodePrd.push(
                    <Draggable key={`Un-${listId}`} draggableId={`Un-${listId}`} index={i}>
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                            >
                                <MyListCard
                                    style={{backgroundColor: snapshot.isDragging?"#e8e9eb":"#f6f7f8"}}
                                    key={listId}
                                    listId={listId}
                                    localization={localization}
                                    productView={productView}
                                    addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                                    width={productDisplayWidth}
                                    deviceType={deviceType}
                                    activeOrder={activeOrder}
                                    labelHeader="Featured"
                                    labelName={productLists.customLists[i].name}
                                    products={productLists.customLists[i].lines}
                                    addMyListToOrder={addMyListToOrder}
                                    downloadListPdf={downloadListPdf}
                                    history={history}
                                    setModal={setModal}
                                    sortLists={true}
                                />
                            </div>
                        )}
                    </Draggable>
                );
            }
        }
        return nodePrd;
    }

    createCards()
    {
        const {
            localization,
            productLists,
            addRemoveProductToTemporaryOrder,
            deviceType,
            activeOrder,
            productView,
            addMyListToOrder,
            downloadListPdf,
            history,
            setModal,
        } = this.props;
        const productDisplayWidth = this.calculateProductDisplayWidth();
        const nodePrd = [];
        for(let i=0; i<productLists.customLists.length; i++) {
            const listId = productLists.customLists[i].myListId;
            if( listId>=0){
                nodePrd.push(
                    <MyListCard
                        key={listId}
                        listId={listId}
                        localization={localization}
                        productView={productView}
                        addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                        width={productDisplayWidth}
                        deviceType={deviceType}
                        activeOrder={activeOrder}
                        labelHeader="Featured"
                        labelName={productLists.customLists[i].name}
                        products={productLists.customLists[i].lines}
                        addMyListToOrder={addMyListToOrder}
                        downloadListPdf={downloadListPdf}
                        history={history}
                        setModal={setModal}
                        sortLists={false}
                    />
                );
            }
        }
        return nodePrd;
    }

    calculateProductDisplayHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;
        
        //page padding
        productDisplayHeight -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;

        if( deviceType==="xs" ) {
            //shopping cart in menu form
            productDisplayHeight -= parseInt(scssVariables.menuHeightWithBorder);
        } else {
            //title tab height
            productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;
            productDisplayHeight -= parseInt(scssVariables.titleTabHeight);
            //searchbar height
            productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;
            productDisplayHeight -= parseInt(scssVariables.menuHeightWithBorder);
        }
        //product display padding
        productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;

        return productDisplayHeight;
    }
    calculateProductDisplayWidth() {
        const {
            deviceType,
            width,
        } = this.props;

        const isTinyDevice = deviceType=="xs" || deviceType=="sm";

        let productDisplayWidth = width;
        if( deviceType==="xs" ) {
            //page padding
            productDisplayWidth -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;
            //product display padding
            productDisplayWidth -= parseInt(scssVariables.cardMargin)*2;
        } else {
            //page padding
            productDisplayWidth -= parseInt(scssVariables[`${deviceType}ContentPadding`]);//no padding on the right side(Attached to it)
            //page padding
            productDisplayWidth -= parseInt(isTinyDevice ? scssVariables.shoppingCartWidthTiny : scssVariables.shoppingCartWidth);
            //product display padding
            productDisplayWidth -= parseInt(scssVariables.cardMargin)*2;
        }

        return productDisplayWidth;
    }
    calculateShoppingCartHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;
        
        //page padding
        productDisplayHeight -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;
        //product display margin
        productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;

        return productDisplayHeight;
    }

    loadMoreSearchResaults() {
        const {
            deviceType,
            loadMoreSearchedProducts,
        } = this.props;
        const productDisplayHeight = this.calculateProductDisplayHeight();
        const rowsToLoad = (Math.floor(productDisplayHeight/parseInt(scssVariables.productItemHeight))+2);
        // rowsToLoad * itemsPerRow
        switch(deviceType){
        case "xs":
        case "sm":
            loadMoreSearchedProducts( rowsToLoad*2 );
            break;
        case "md":
            loadMoreSearchedProducts( rowsToLoad*4 );
            break;
        case "lg":
            loadMoreSearchedProducts( rowsToLoad*6 );
            break;
        default:
            loadMoreSearchedProducts( rowsToLoad*8 );
            break;
        }
    }

    createNewList(){
        this.props.createNewMyList(this.props.history);
    }
    sortLists(){
        this.props.setMyListsSortingMode(!this.props.sortLists);
    }

    render(){
        const {
            deviceType,
            localization,
            activeOrder,
            addRemoveProductToTemporaryOrder,
            height,
            width,
            submitOrder,
            deliveryDates,
            setActiveOrder,
            moveUnconfirmedLinesToNextOrder,
            setModal,
            setDropDown,
            orderFeeLimits,
            orderVolumeDiscounts,
            newSeasonDistrDates,
            showFreshFood,
            sortLists,
        } = this.props;
        const shoppingCartHeight = this.calculateShoppingCartHeight();

        const isTinyDevice = deviceType=="xs" || deviceType=="sm";

        return deviceType=="xs" ? (
            <ContentWrapper height={height}>
                <div className="my-list-left-backgorund" >
                    <div style={{padding:"right"}}>
                        <button className={"btn icon"} style={{float:"right"}} onClick={this.createNewList} disabled={false}>
                            <Icon type={iconTypes.plus} color={iconColor.red}/>
                            {localization.text("list","newList")}
                        </button>
                        <button className={"btn icon"} style={{float:"right"}} onClick={this.sortLists} disabled={false}>
                            <Icon type={iconTypes.draggable}/>
                            {localization.text("list",sortLists ? "endListSorting" : "sortLists")}
                        </button>
                    </div>
                    {sortLists ? this.createDraggableLists() : this.createCards()}
                    <ShoppingCart
                        localization={localization}
                        height={shoppingCartHeight}
                        deviceType={deviceType}
                        width={width}
                        activeOrder={activeOrder}
                        addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                        submitOrder={submitOrder}
                        deliveryDates={deliveryDates}
                        setActiveOrder={setActiveOrder}
                        moveUnconfirmedLinesToNextOrder={moveUnconfirmedLinesToNextOrder}
                        setModal={setModal}
                        setDropDown={setDropDown}
                        orderFeeLimits={orderFeeLimits}
                        orderVolumeDiscounts={orderVolumeDiscounts}
                        newSeasonDistrDates={newSeasonDistrDates}
                    />
                </div>
            </ContentWrapper>
        ) : (
            <ContentWrapper height={height} paddingRight={false}>
                <div style={{display:"flex", height:"100%"}} >
                    <div className="my-list-left-backgorund" >
                        <TitleTabs>
                            <TitleTab label={localization.text("order","TitleTab","Products")} url={"/order/products"} deviceType={deviceType} />
                            <TitleTab label={localization.text("order","TitleTab","Campaigns")} url={"/order/campaigns"} deviceType={deviceType} />        
                            <TitleTab label={localization.text("order","TitleTab","List")} url={"/order/lists"} deviceType={deviceType} />
                            { showFreshFood && (
                                <TitleTab label={localization.text("order","TitleTab","FreshFoodTemplate")} url={"/order/freshfoodTemplate"} deviceType={deviceType} />
                            )} 
                        </TitleTabs>
                        {sortLists ? this.createDraggableLists() : this.createCards()}
                        <button className={"btn icon"} style={{float:"right"}} onClick={this.createNewList} disabled={false}>
                            <Icon type={iconTypes.plus} color={iconColor.red}/>
                            {localization.text("list","newList")}
                        </button>
                        <button className={"btn icon"} style={{float:"right"}} onClick={this.sortLists} disabled={false}>
                            <Icon type={iconTypes.draggable}/>
                            {localization.text("list",sortLists ? "endListSorting" : "sortLists")}
                        </button>
                    </div>
                    <div style={{height:"100%", flex: `0 0 ${isTinyDevice ? scssVariables.shoppingCartWidthTiny : scssVariables.shoppingCartWidth}`}} >
                        <ShoppingCart
                            localization={localization}
                            height={shoppingCartHeight}
                            width={width}
                            deviceType={deviceType}
                            activeOrder={activeOrder}
                            addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                            submitOrder={submitOrder}
                            deliveryDates={deliveryDates}
                            setActiveOrder={setActiveOrder}
                            moveUnconfirmedLinesToNextOrder={moveUnconfirmedLinesToNextOrder}
                            setModal={setModal}
                            setDropDown={setDropDown}
                            orderFeeLimits={orderFeeLimits}
                            orderVolumeDiscounts={orderVolumeDiscounts}
                            newSeasonDistrDates={newSeasonDistrDates}
                        />
                    </div>
                </div>
            </ContentWrapper>
        );
    }
}

MyListPage.propTypes = {
    //Required
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    setOrderProductView: PropTypes.func.isRequired,
    productView: PropTypes.object.isRequired,
    activeOrder: PropTypes.object.isRequired,
    addRemoveProductToTemporaryOrder: PropTypes.func.isRequired,
    editQueryFilter: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    loadMoreSearchedProducts: PropTypes.func.isRequired,
    productQuery: PropTypes.object.isRequired,
    submitOrder: PropTypes.func.isRequired,
    deliveryDates: PropTypes.array.isRequired,
    setActiveOrder: PropTypes.func.isRequired,
    productLists: PropTypes.object.isRequired,
    getMyLists: PropTypes.func.isRequired,
    createNewMyList: PropTypes.func.isRequired,
    addMyListToOrder: PropTypes.func.isRequired,
    downloadListPdf: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    initiateCurrentOrder: PropTypes.func.isRequired,
    moveUnconfirmedLinesToNextOrder: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    getOrderFeeLimits: PropTypes.func.isRequired,
    orderFeeLimits: PropTypes.array.isRequired,
    getOrderVolumeDiscounts: PropTypes.func.isRequired,
    orderVolumeDiscounts: PropTypes.array.isRequired,
    newSeasonDistrDates: PropTypes.array.isRequired,
    showFreshFood: PropTypes.bool.isRequired,
    updateListSortOrder: PropTypes.func.isRequired,
    sortLists: PropTypes.bool.isRequired,
    setMyListsSortingMode: PropTypes.func.isRequired,
};

export default withRouter(MyListPage);